module.exports = __webpack_public_path__ + "static/media/arrow-right.33f45651.svg";